<template>
  <div id="app">
    <Navbar />
    <router-view />
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default {
  components: { Footer, Navbar },
 };
</script>
  
<style>
</style>

